import React, { Fragment } from 'react'
import {
  LEGAL_FORM_VALUES,
  SIZES_VALUES
} from '../../constants'

import { FormattedMessage } from '@dragonraider5/react-intl'
import { Link } from 'react-router-dom'
import { showFieldError, renderValidation } from '../../../../../utils/validations'
import { getExceptionMessage } from '../../../../../utils/exceptions'
import Button from '../../../../../components/Button'
import FormRow from '../../../../../components/FormFields/FormRow'
import TextField from '../../../../../components/FormFields/TextField'
import DateField from '../../../../../components/FormFields/DateField'
import SelectField from '../../../../../components/FormFields/SelectField'
import FormActions from '../../../../../components/FormFields/FormAction/FormActions'
import FormError from '../../../../../components/FormFields/FormError'
import { P, List, ListItem } from '../../../../../components/Tip'
import valueMessages from './valueMessages'
import validationMessages from './validationMessages'

import { getApplyToStepPath } from '../../../../MainRoutes/utils'
import { stepStatuses } from '../../../constants'
import { StatusSteps } from '../../StatusSteps'

const LEGAL_FORM_OPTIONS = [
  LEGAL_FORM_VALUES.SL,
  LEGAL_FORM_VALUES.SA,
  LEGAL_FORM_VALUES.FUNDATION,
  LEGAL_FORM_VALUES.ASSOCIATION,
  LEGAL_FORM_VALUES.COOPERATIVE,
  LEGAL_FORM_VALUES.CIVIL,
  LEGAL_FORM_VALUES.COMMUNITIES_GOODS,
  LEGAL_FORM_VALUES.AIE,
  LEGAL_FORM_VALUES.SAT,
  LEGAL_FORM_VALUES.CONGREGATIONS,
  LEGAL_FORM_VALUES.UTE,
  LEGAL_FORM_VALUES.FREELANCE,
  LEGAL_FORM_VALUES.OTHERS
]

function DataForm({
  values,
  status = {},
  errors,
  touched,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
  application
}) {
  return (
    <form onSubmit={handleSubmit}>
      <FormRow>
        <TextField
          type='text'
          name='name'
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('name', { errors, touched })}
          help={renderValidation('name', { errors, touched })}
          label='Nombre de la organización'
          full
        />
      </FormRow>
      <FormRow>
        <TextField
          type='text'
          name='cif'
          value={values.cif}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('cif', { errors, touched })}
          help={renderValidation('cif', { errors, touched })}
          label='CIF / NIF'
          full
        />
      </FormRow>
      <FormRow>
        <DateField
          name='constitution'
          value={values.constitution}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('constitution', { errors, touched })}
          help={renderValidation('constitution', { errors, touched }, validationMessages)}
          label='Fecha de constitución'
          shrinkLabel
          full
        />
      </FormRow>
      <FormRow>
        <SelectField
          name='legal_form'
          value={values.legal_form}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('legal_form', { errors, touched })}
          help={renderValidation('legal_form', { errors, touched })}
          label='Forma jurídica'
          full
        >
          <option value='' />
          {LEGAL_FORM_OPTIONS.map(value => (
            <FormattedMessage key={value} {...valueMessages[`legalFormTypes${value}`]}>
              {message => <option value={value}>{message}</option>}
            </FormattedMessage>
          ))}
        </SelectField>
      </FormRow>
      {values.legal_form === LEGAL_FORM_VALUES.OTHERS.toString() && (
        <FormRow>
          <TextField
            type='text'
            name='other_legal_form'
            value={values.other_legal_form}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showFieldError('other_legal_form', { errors, touched })}
            help={renderValidation('other_legal_form', { errors, touched })}
            label='Especifica la forma jurídica de tu organización'
            full
          />
        </FormRow>
      )}
      <FormRow>
        <TextField
          type='text'
          name='address'
          value={values.address}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('address', { errors, touched })}
          help={renderValidation('address', { errors, touched })}
          label='Dirección'
          full
        />
      </FormRow>
      <FormRow>
        <TextField
          type='text'
          name='locality'
          value={values.locality}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('locality', { errors, touched })}
          help={renderValidation('locality', { errors, touched })}
          label='Localidad'
          full
        />
      </FormRow>
      <FormRow>
        <TextField
          type='text'
          name='zip_code'
          value={values.zip_code}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('zip_code', { errors, touched })}
          help={renderValidation('zip_code', { errors, touched })}
          label='Código Postal'
        />
        <TextField
          type='text'
          name='province'
          value={values.province}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('province', { errors, touched })}
          help={renderValidation('province', { errors, touched })}
          label='Provincia'
        />
      </FormRow>
      <FormRow>
        <TextField
          type='text'
          name='web'
          value={values.web}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('web', { errors, touched })}
          help={renderValidation('web', { errors, touched })}
          label='Página web'
          full
        />
      </FormRow>
      <FormRow>
        <SelectField
          name='size'
          value={values.size}
          onChange={handleChange}
          onBlur={handleBlur}
          error={showFieldError('size', { errors, touched })}
          help={renderValidation('size', { errors, touched })}
          label='Tamaño de la organización'
          tip={
            (
              <Fragment>
                <P>Para seleccionar el tamaño de tu organización utiliza esta guía:</P>
                <List>
                  <ListItem><strong>Grandes:</strong> Más de 250 empleados y una cifra de negocio mayor que 50 millones de Euros o un resultado de balance de más de 43 millones de Euros</ListItem>
                  <ListItem><strong>Medianas:</strong> hasta 250 empleados y una cifra de negocio hasta 50 millones de euros o un resultado de balance hasta 43 millones de euros</ListItem>
                  <ListItem><strong>Pequeñas:</strong> hasta 50 empleados y una cifra de negocios de 10 millones de euros o un resultado de balance hasta 10 millones de euros</ListItem>
                </List>
              </Fragment>
            )
          }
          forceTip
          full
        >
          <option value='' />
          {Object.values(SIZES_VALUES).map(value => (
            <FormattedMessage key={value} {...valueMessages[`sizesTypes${value}`]}>
              {message => <option value={value}>{message}</option>}
            </FormattedMessage>
          ))}
        </SelectField>
      </FormRow>
      {status.error && (
        <FormError>
          <FormattedMessage {...getExceptionMessage(status.error)} />
        </FormError>
      )}
      <FormActions>
        <Button type='submit' disabled={isSubmitting}>Continuar</Button>
        <Link to={getApplyToStepPath(stepStatuses.INFO, application)}>Volver</Link>
      </FormActions>
      <StatusSteps />
    </form>
  )
}

export default DataForm
